import React from 'react';
import { Button } from '@/app/components/ui/Button';
import { cn } from '@/lib/utils';
import { ChevronLeft } from 'lucide-react';

interface FormNavigationProps {
  onBack?: () => void;
  onNext?: () => void;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  isValid?: boolean;
  isSubmitting?: boolean;
}

export const FormNavigation = ({
  onBack,
  onNext,
  isFirstStep = false,
  isLastStep = false,
  isValid = true,
  isSubmitting = false,
}: FormNavigationProps) => {
  return (
    <div className="w-full pt-6 mt-6 border-t border-gray-200">
      <div className={cn(
        "flex gap-3 md:w-1/2",
        !onBack
          ? "justify-start"
          : "flex-col-reverse sm:flex-row sm:justify-between"
      )}>
        {onBack && (
          <Button
            type="button"
            variant="ghost"
            onClick={onBack}
            disabled={isSubmitting}
            className="w-full sm:w-auto text-gray-500 hover:text-gray-800 hover:bg-transparent hover:-translate-x-1 transition-transform pl-2"
          >
            <ChevronLeft className="w-4 h-4 mr-1" /> Back
          </Button>
        )}
        <Button
          type={onNext ? "button" : "submit"}
          onClick={onNext}
          disabled={!isValid || isSubmitting}
          className={cn('w-full sm:w-auto', isSubmitting ? 'opacity-70 cursor-wait' : '')}
          variant="primary"
        >
          {isLastStep ? 'Complete & Pay' : 'Next'}
        </Button>
      </div>
    </div>
  );
};

